import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import ItemModify from '../Form/ItemModify';

@inject('metaDataStore')
@observer
class MetaDataModify extends Component {
  render() {
    const { metaDataStore, params} = this.props;
    return (
       <ItemModify
       title='Meta Data'
       slug = '/configurations/meta-data/meta-data'
       store = {metaDataStore}
       itemFields = {[
         { label: 'Id', key: 'id', type: 'text', readOnly:true, editOnly:true },
         { label: 'Name', key: 'name', type: 'text' },
         { label: 'Caption', key: 'caption', type: 'text' },
         { label: 'Description', key: 'description', type: 'text' }
       ]}
       params={params}
       />
     )
  }
}

export default MetaDataModify;



// WEBPACK FOOTER //
// ./src/components/MetaData/MetaDataModify.js